import { useGetReceptionVolumeByDayAndUserQuery } from "@/redux/services/recordApi";
import { Alert, Card, Divider, Flex, List, Spin, Typography } from "antd";
import ReactEcharts from "echarts-for-react";

export function DistributionGraphDayBar({ selectedDateByDay }) {
	const {
		isError: isDayError,
		isLoading: isDayLoading,
		data: isDayData,
	} = useGetReceptionVolumeByDayAndUserQuery(selectedDateByDay);

	if (isDayError) {
		return (
			<Alert
				message="Error"
				description="Something went wrong ..."
				type="error"
				showIcon
			/>
		);
	}

	if (isDayLoading) {
		return (
			<Flex
				justify="center"
				align="center"
				style={{ width: "100%", height: "50vh" }}
			>
				<Spin size="large" />
			</Flex>
		);
	}

	let xAxisData = [];
	let seriesData = [];

	let topSalesTrip = [];

	if (isDayData) {
		const sortedData = Object.entries(isDayData).sort((a, b) => {
			return (
				parseInt(b[1].period_traffic) - parseInt(a[1].period_traffic)
			);
		});
		xAxisData = sortedData.map((item) => item[0]);
		seriesData = sortedData.map((item) => parseInt(item[1].period_traffic));
		topSalesTrip = sortedData.slice(0, 3);
	}

	const getOption = () => {
		let option = {
			grid: {
				left: "15%",
				bottom: "40%", // 调整左边距，增大左边显示标签的区域
			},
			xAxis: {
				type: "category",
				data: xAxisData,
				axisLabel: {
					interval: 0, // 强制显示所有标签
					rotate: 45, // 标签旋转45度角
					margin: 10, // 标签与轴线之间的距离
				},
			},
			yAxis: {
				type: "value",
				name: "人数",
				nameLocation: "end",
				nameTextStyle: {
					fontSize: 14,
					padding: [0, 0, 10, 0], // 上右下左
				},
			},
			series: [
				{
					data: seriesData,
					type: "bar",
					areaStyle: {},
					smooth: true,
					label: {
						show: true,
						position: "top",
					},
					emphasis: {
						focus: "series",
					},
					itemStyle: {
						color: "#FD665F",
					},
				},
			],
			tooltip: {
				trigger: "axis",
				axisPointer: {
					type: "cross",
					label: {
						backgroundColor: "#6a7985",
					},
				},
			},
		};
		return option;
	};

	return (
		<>
			{isDayData != null && isDayData != null && (
				<Card
					style={{
						border: "1px solid #FD665F",
						minWidth: "800px",
						paddingBottom: "30px",
					}}
					title="订单来源"
					styles={{
						header: {
							backgroundColor: `#FD665F`,
						},
					}}
				>
					<List
						header={
							<Typography.Title level={5}>
								Top 3 订单来源
							</Typography.Title>
						}
						bordered
						dataSource={topSalesTrip}
						renderItem={(item) => (
							<List.Item className="list-item">
								<span className="item-name">{item[0]}</span>
								<span className="item-traffic">
									{item[1].period_traffic}
								</span>
							</List.Item>
						)}
						style={{
							boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
							border: "1px solid rgba(0, 0, 0, 0.2)",
							marginBottom: "30px",
						}}
						className="custom-list"
					/>
					<Divider>展示图</Divider>

					<div
						style={{
							width: "100%",
							margin: "0 auto",
							height: "500px",
						}}
					>
						<ReactEcharts
							option={getOption()}
							style={{ width: "100%", height: "100%" }}
						/>
					</div>
				</Card>
			)}
		</>
	);
}
